import { render } from "./Student_Age_Group_List.vue?vue&type=template&id=04e77cc3&ts=true"
import script from "./Student_Age_Group_List.vue?vue&type=script&lang=ts"
export * from "./Student_Age_Group_List.vue?vue&type=script&lang=ts"

import "./Student_Age_Group_List.vue?vue&type=style&index=0&id=04e77cc3&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__